// defined by our data analysts - used to classify non-organic visits as deep links
const DEEP_LINK_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign']

// defined by our data analysts - used to classify non-organic visits as appsflyer
const APPS_FLYER_PARAMS = ['pid', 'c', 'af_channel', 'deep_link_value', 'deep_link_sub1', 'deep_link_sub3', 'af_sub3']

const SESSION_ATTRIBUTION_TYPE = {
    APPS_FLYER_LINK: 2,
    DEEP_LINK: 3,
}

/**
 * Retrieves all query params in the url
 * Used only upon analytics init so we can check for organic/non-organic session starts
 * @returns {Object<string, string>|null} An object with key/value pairs of current url query params or null when no query params present
 */
function getQueryParams() {
    // eslint-disable-next-line compat/compat
    const rawQueryParams = new URLSearchParams(window.location.search)

    const queryParamsList = Array.from(rawQueryParams.entries())

    if (queryParamsList.length) {
        return Object.fromEntries(queryParamsList.map(([key, value]) => [key, value]))
    }

    return null
}

/**
 * Checks if the query params provided can be classified as deeplink or appsflyer params then maps them accordingly
 * @param queryParams{Object<string, string>}
 * @returns {Object} Proto ready object of known re-engagement query params & session attribution type
 */
function mapQueryParams(queryParams) {
    const paramKeys = Object.keys(queryParams)

    if (APPS_FLYER_PARAMS.some(param => paramKeys.includes(param))) {
        return {
            ...mapReEngagementEvent(queryParams, true),
            sessionAttributionType: SESSION_ATTRIBUTION_TYPE.APPS_FLYER_LINK,
        }
    }

    if (DEEP_LINK_PARAMS.some(param => paramKeys.includes(param))) {
        return {
            ...mapReEngagementEvent(queryParams),
            sessionAttributionType: SESSION_ATTRIBUTION_TYPE.DEEP_LINK,
        }
    }

    return null
}

/**
 * Maps url params to the predefined deep link analytics object
 * @param {Object.<string, string>} queryParams
 * @returns {Object} LinkPayload object of known re-engagement query params
 */
function mapReEngagementEvent(queryParams, removeDeepLinkContent = false) {
    return {
        linkPayload: {
            campaign: {
                value: queryParams.utm_campaign || queryParams.c || null,
            },
            deepLinkContent: {
                value: removeDeepLinkContent ? null : window.location.search || null,
            },
            medium: {
                value: queryParams.utm_medium || queryParams.af_channel || null,
            },
            promoCode: {
                value: queryParams.deep_link_sub2 || queryParams.af_sub1 || null,
            },
            referralParams: {
                value: queryParams.deep_link_sub3 || queryParams.af_sub3 || null,
            },
            shareParams: {
                value: queryParams.deep_link_sub1 || null,
            },
            source: {
                value: queryParams.utm_source || queryParams.pid || null,
            },
        },
    }
}

export { getQueryParams, mapQueryParams }
